export const allowlistAddresses = [


  ["0xdecf4b112d4120b6998e5020a6b4819e490f7db6",1],

]